module.exports = __webpack_public_path__ + "static/chirurgia-palca-image-3-d2523b18d3c928b7fd3cd880ee059335.png";